import Constant from 'BASE/common/lotteryConstant';

// extraParameter: 額外傳入參數
// showSubGame: 是否顯示子遊戲(預設進入大廳)
export default [
    {
        category: 'live',
        categoryName: '真人',
        fullName: '真人娱乐',
        games: [
            {
                type: Constant.GameType.EGP_AG,
                name: 'Choice真人',
            },
            {
                type: Constant.GameType.EGP_BBIN,
                name: 'BBIN真人',
                extraParameter: 'live',
            },
            {
                type: Constant.GameType.ALLBET,
                name: '欧博真人',
            },
            {
                type: Constant.GameType.WM,
                name: 'WM真人',
            },
            {
                type: Constant.GameType.HRG,
                name: 'HR视讯',
            },
        ],
    },
    {
        category: 'slot',
        categoryName: '电子',
        fullName: '电子游艺',
        games: [
            {
                type: Constant.GameType.TIKI,
                name: 'TIKI电子',
                showSubGame: true,
            },
            {
                type: Constant.GameType.PG,
                name: 'PG电子',
            },
            {
                type: Constant.GameType.PP,
                name: 'PP电子',
            },
            {
                type: Constant.GameType.EGP_JDB,
                name: 'JDB电子',
            },
            {
                type: Constant.GameType.EGP_CQ9,
                name: 'CQ9电子',
            },
            {
                type: Constant.GameType.EGP_FC,
                name: '发财电子',
            },
        ],
    },
    {
        category: 'card',
        categoryName: '棋牌',
        fullName: '棋牌游戏',
        games: [
            {
                type: Constant.GameType.EGP_KY,
                name: 'KY开元棋牌',
            },
            {
                type: Constant.GameType.EGP_LEG,
                name: 'LEG乐游棋牌',
            },
            {
                type: Constant.GameType.WALI,
                name: '瓦力棋牌',
            },
        ],
    },
    {
        category: 'sport',
        categoryName: '体育',
        fullName: '体育竞技',
        games: [
            {
                type: Constant.GameType.EGP_CR,
                name: '皇冠体育',
            },
            {
                type: Constant.GameType.XBB,
                name: 'WE世界体育',
            },
            {
                type: Constant.GameType.BTI2,
                name: 'BTi体育',
            },
        ],
    },
];
